import React, { useState } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { token } from "../../config";
import { useEffect } from "react";
import config from "../../config";
import { json, useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import Spinner from "../../component/loadingbar/Spinner";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const AddMcqBank = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  //------------------------------------------- State management -------------------------------------------
  const [loading, setLoading] = useState(false);
  const [mcqBankName, setMcqBankName] = useState("");
  const [difficulty, setDifficulty] = useState("easy");
  const [isFree, setIsFree] = useState(false);
  const [suffleForQue, setSuffleForQue] = useState(0);
  const [suffleForOpt, setSuffleForOpt] = useState(0);
  const [timer, setTimer] = useState({
    set_exam_timer: false,
    exam_timer: "",
    set_que_timer: false,
    que_timer: "",
    set_warning: false,
    warning_seconds: "",
  });
  const [scrnOrientations, setScrnOrientations] = useState([
    { value: "all", label: "All", id: "so1" },
    { value: "landscape", label: "Landscape", id: "so2" },
    { value: "portrait", label: "Portrait", id: "so3" },
    { value: "jee", label: "JEE / NEET", id: "so4" },
    { value: "mht-cet", label: "MHT-CET", id: "so5" },
  ]);
  const [pattern, setPattern] = useState([
    { value: "all", label: "All", id: "so1" },
  ]);
  const [bankFor, setBankFor] = useState({
    bFor: "chapterid",
    cid: "",
    chapters: [],
    courses: [],
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  //state change handler function
  const handleMcqBankNmChange = (e) => {
    setMcqBankName(e.target.value);
  };
  const handleDifficultyChange = (e) => {
    setDifficulty(e);
  };
  const handleIsFreeChange = (e) => {
    setIsFree(!isFree);
  };
  const handleMcqBankPatternChange = (selectedOptions) => {
    console.log(selectedOptions);
    selectedOptions.some((so) => so.value === "all")
      ? setPattern([{ value: "all", label: "All", id: "so1" }])
      : setPattern(selectedOptions);
  };

  const handleChapCourChangeDropdown = (option) => {
    setBankFor((prevData) => ({
      ...prevData,
      cid: option,
    }));
  };

  //-----------------------------------------------------------------------------------------
  const handleTimerBtn = (target) => {
    // console.log(target);
    setTimer((prevData) => {
      // Create a copy of the previous state
      const newData = { ...prevData };

      // Determine which timer to toggle based on the button's id
      if (target === "examTimer") {
        newData.set_exam_timer = !prevData.set_exam_timer;
      } else if (target === "queTimer") {
        newData.set_que_timer = !prevData.set_que_timer;
      } else if (target === "wrngTimer") {
        newData.set_warning = !prevData.set_warning;
      }

      return newData;
    });
  };
  const timerValueChange = (e) => {
    setTimer((prevData) => ({
      ...prevData,
      [e.target.id]: e.target.value,
    }));
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setBankFor((prevData) => ({
      ...prevData,
      cid: "",
    }));
    setMcqBankName("");
    setDifficulty("");
    setPattern("");
    setTimer({
      set_exam_timer: false,
      exam_timer: "",
      set_que_timer: false,
      que_timer: "",
      set_warning: false,
      warning_seconds: "",
    });
    if (id) {
      navigate("/viewmcqbank");
    }
  };

  //-------------------------------------- get / read chapter for dropdown option --------------------------------------r
  useEffect(() => {
    // Fetch chapter list
    fetch(`${config.host_url}chapter`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            chapters: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chapter:", error);
      });

    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            courses: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching course:", error);
      });
  }, [token]);

  //--------------------------------------------------- create / add / update mcqbanks  -------------------------------------------------u--C
  const createMcqBanksBtn = async () => {
    if (
      !mcqBankName.trim() ||
      // !bankFor.cid.trim() ||
      !bankFor.bFor.trim() ||
      pattern.length === 0
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return;
    }
    try {
      const bodyData = {
        bank_name: mcqBankName,
        bank_difficulty: difficulty,
        [bankFor.bFor]: bankFor.cid,
        pattern: pattern.map((screen) => screen.value).join(","),
        isFree: isFree ? "1" : "0",
        set_exam_timer: timer.set_exam_timer ? "1" : "0",
        set_que_timer: timer.set_que_timer ? "1" : "0",
        set_warning: timer.set_warning ? "1" : "0",
        shuffle_question: suffleForQue == 1 ? 1 : 0,
        shuffle_option: suffleForOpt == 1 ? 1 : 0
      };
      if (timer.set_exam_timer) {
        if (timer.exam_timer < 1) {
          triggerNotification(
            "error",
            "Please enter a valid exam timer or deselect the 'Set Exam Timer' checkbox."
          );
          return;
        }
        bodyData.exam_timer = timer.exam_timer;
      }

      if (timer.set_que_timer) {
        if (timer.que_timer < 1) {
          triggerNotification(
            "error",
            "Please enter a valid question timer or deselect the 'Set Question Timer' checkbox."
          );
          return;
        }
        bodyData.que_timer = timer.que_timer;
      }

      if (timer.set_warning) {
        if (timer.warning_seconds < 1) {
          triggerNotification(
            "error",
            "Please enter a valid warning timer or deselect the 'Set Warning Timer' checkbox."
          );
          return;
        }
        bodyData.warning_seconds = timer.warning_seconds;
      }

      await fetch(
        `${config.host_url}mcqbanks/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify(bodyData),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `mcq bank ${id ? "updated" : "created"} successfully.`
            );

            setBankFor((prevData) => ({
              ...prevData,
              bFor: "chapterid",
              cid: "",
            }));
            setMcqBankName("");
            setTimer({
              set_exam_timer: false,
              exam_timer: "",
              set_que_timer: false,
              que_timer: "",
              set_warning: false,
              warning_seconds: "",
            });
            navigate(
              `/viewmcqbank/${bankFor.bFor}/${btoa(
                encodeURIComponent(bankFor.cid)
              )}`
            );
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating mcq bank:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the mcq bank."
      );
    }
  };

  // ---------------------------------------------- get data for update / edit class ----------------------------------------------------r
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}mcqbanks/edit/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log("mcq:", data.data);
          setDifficulty(String(data.data.bank_difficulty));
          setMcqBankName(String(data.data.bank_name));
          setSelectedValue(data.data);
          const fetchPattern = data.data.pattern;
          const selectedPatterns = fetchPattern
            .split(",")
            .map((patternValue) => {
              return scrnOrientations.find(
                (option) => option.value === patternValue
              );
            });
          setPattern(selectedPatterns);
          setIsFree(data.data?.isFree === 0 ? false : true);

          setTimer({
            set_exam_timer: data.data?.set_exam_timer === 0 ? false : true,
            exam_timer: data.data?.exam_timer,
            set_que_timer: data.data?.set_que_timer === 0 ? false : true,
            que_timer: data.data?.que_timer,
            set_warning: data.data?.set_warning === 0 ? false : true,
            warning_seconds: data.data?.warning_seconds,
          });
          setBankFor((prevData) => ({
            ...prevData,
            bFor: data.data.chapterid ? "chapterid" : "courseid",
            cid: String(
              data.data.chapterid ? data.data.chapterid : data.data.courseid
            ),
          }));
          // setSelectedChapter(String(data.data.chapterid));
          setLoading(false);
        });
    }
  }, [id]);

  //---------------------------------------------- bank for course or chapter ----------------------------------------------
  const handleRadioChange = (e) => {
    if (e.target.value === "courseid") {
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "courseid",
      }));
    } else if (e.target.value === "chapterid") {
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "chapterid",
      }));
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const closeDropdown = (event) => {
    if (isDropdownOpen && !event.target.closest('.dropdown')) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeDropdown);
    return () => {
      document.removeEventListener('mousedown', closeDropdown);
    };
  }, [isDropdownOpen]);

  const uniqueOptions = bankFor.bFor === "chapterid"
    ? Array.from(new Set(bankFor.chapters.map(chapter => chapter.chapterid)))
      .map(id => bankFor.chapters.find(chapter => chapter.chapterid === id))
    : bankFor.bFor === "courseid"
      ? Array.from(new Set(bankFor.courses.map(course => course.course_id)))
        .map(id => bankFor.courses.find(course => course.course_id === id))
      : [];

  const filteredOptions = uniqueOptions.filter(option =>
    bankFor.bFor === "chapterid"
      ? option.name.toLowerCase().includes(searchTerm.toLowerCase())
      : option.course_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionSelect = (option) => {
    setSelectedValue(option);
    handleChapCourChangeDropdown(option);
    setIsDropdownOpen(false);
  };

  return (
    <>
      <Breadcrumb
        txt="Manage MCQ "
        subpath={[id ? "Edit MCQ Bank" : "Add MCQ Bank"]}
      />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">{id ? "Edit MCQ Bank" : "Add MCQ Bank"}</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* MCQ Bank name  | set as free */}
                <div className="row">
                  {/* MCQ Bank name  */}
                  <div className="col-lg-9 ">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="mcq_bank"
                        id="mcq_bank"
                        placeholder="MCQ Bank Name "
                        value={mcqBankName}
                        onChange={handleMcqBankNmChange}
                      />
                      <label htmlFor="mcq_bank"> MCQ Bank Name </label>
                    </div>
                  </div>
                  {/* set as free */}
                  <div className="col-sm-3  ">
                    <div
                      className="mb-4 font-bold h-[45px] bg-green-600 px-3 select-none flex justify-center items-center rounded text-white"
                      onClick={() => handleIsFreeChange()}
                    >
                      {isFree ? (
                        <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                      ) : (
                        <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                      )}
                      SET AS FREE
                      <span
                        style={{
                          visibility: isFree ? "hidden" : "visible",
                        }}
                      >
                        ?
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-2 flex-grow-1">
                  <div className=" form-floating form-floating-outline mb-4">
                    <select
                      className="form-select mx-auto"
                      id="difficulty"
                      aria-label="difficulty"
                      name="difficulty"
                      value={difficulty}
                      onChange={(e) =>
                        handleDifficultyChange(e.target.value)
                      }
                    >
                      <option value="easy">
                        easy
                      </option>
                      <option value="medium">
                        medium
                      </option>
                      <option value="hard">
                        hard
                      </option>

                    </select>
                    <label htmlFor="difficulty">
                      Bank Difficulty Level
                    </label>
                  </div>
                </div>

                {/* Screen Orientation  */}
                <div className="">
                  <div className="form-floating form-floating-outline mb-4">
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      isMulti
                      options={scrnOrientations}
                      value={pattern}
                      placeholder="MCQ Layout"
                      onChange={handleMcqBankPatternChange}
                    />
                  </div>
                </div>

                {/* chapter / course selection  */}
                {
                  id ? (
                    selectedValue.chapter_name ? (
                      <label className="form-check-label ml-1 mb-2 font-bold">
                        Chapter is: {selectedValue.chapter_name}
                      </label>
                    ) : (
                      <label className="form-check-label ml-1 mb-2 font-bold">
                        Course is: {selectedValue.course_name}
                      </label>
                    )
                  ) : null
                }

                {
                  !id && (
                    <>
                      <div className="col mt-2">
                        <div className="form-check form-check-inline ml-1">
                          <input
                            defaultChecked
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value="chapterid"
                            id="chapter"
                            checked={bankFor.bFor === "chapterid"}
                            onChange={handleRadioChange}
                          />
                          <label className="form-check-label" htmlFor="chapter">
                            Chapter
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="form-check-group-image"
                            className="form-check-input"
                            type="radio"
                            value="courseid"
                            id="course"
                            checked={bankFor.bFor === "courseid"}
                            onChange={handleRadioChange}
                          />
                          <label className="form-check-label" htmlFor="course">
                            Course
                          </label>
                        </div>
                      </div>

                      {/* chapter / course   */}
                      <div className="col-md-12 mt-2 dropdown">
                        <div className="form-floating form-floating-outline mb-4">
                          <div className={`form-control w-100 ${selectedValue ? 'text-left' : 'text-center'}`} onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                            {selectedValue
                              ? bankFor.bFor === "chapterid"
                                ? bankFor.chapters.find(chapter => chapter.chapterid === selectedValue)?.name
                                : bankFor.courses.find(course => course.course_id === selectedValue)?.course_name
                              : bankFor.bFor === "chapterid"
                                ? "---- Select Chapter ----"
                                : bankFor.bFor === "courseid"
                                  ? "---- Select Course ----"
                                  : "Please first select MCQ Bank For"}
                          </div>

                          {isDropdownOpen && (
                            <div className="dropdown-menu show w-100 p-2" style={{ maxHeight: '162px', overflowY: 'auto' }}>
                              <input
                                type="text"
                                className="form-control mb-2 w-100"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                autoFocus
                              />

                              <div className="dropdown-divider w-100"></div>
                              {filteredOptions.length > 0 ? (
                                filteredOptions.map((option, i) => (
                                  <div
                                    key={i}
                                    className="dropdown-item w-100"
                                    onClick={() => handleOptionSelect(bankFor.bFor === "chapterid" ? option.chapterid : option.course_id)}
                                  >
                                    {bankFor.bFor === "chapterid" ? option.name : option.course_name}
                                  </div>
                                ))
                              ) : (
                                <div className="dropdown-item text-muted">No options found</div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )
                }


                {/* set Exam Timer | set Question Timer | set warning */}
                <div className="row">
                  {/* Exam Timer */}
                  <div className="col-md-4 my-auto">
                    <div className="">
                      <div
                        className="mb-3  select-none"
                        id="examTimer"
                        name="examTimer"
                        onClick={() => handleTimerBtn("examTimer")}
                      >
                        {timer.set_exam_timer ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Set Exam Timer</span>
                        <span
                          style={{
                            visibility: timer.set_exam_timer
                              ? "hidden"
                              : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Question Timer */}
                  <div className="col-md-4 my-auto">
                    <div className="">
                      <div
                        className="mb-3 select-none"
                        id="queTimer"
                        name="queTimer"
                        onClick={() => handleTimerBtn("queTimer")}
                      >
                        {timer.set_que_timer ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Set Question Timer</span>
                        <span
                          style={{
                            visibility: timer.set_que_timer
                              ? "hidden"
                              : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Warning Timer */}
                  <div className="col-md-4 my-auto">
                    <div className="">
                      <div
                        className="mb-3 select-none"
                        id="wrngTimer"
                        name="wrngTimer"
                        onClick={() => handleTimerBtn("wrngTimer")}
                      >
                        {timer.set_warning ? (
                          <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                        ) : (
                          <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                        )}
                        <span>Set Warning Timer</span>
                        <span
                          style={{
                            visibility: timer.set_warning
                              ? "hidden"
                              : "visible",
                          }}
                        >
                          ?
                        </span>
                      </div>
                    </div>
                  </div>
                </div>



                {/*  Exam Time (In Minutes) |  que Timer (In Minutes) | warning (In Minutes)*/}
                <div className="row">
                  {/*  Exam Time (In Minutes)  */}
                  <div className="col-lg-4 ">
                    {timer.set_exam_timer && (
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          name="exam_timer"
                          id="exam_timer"
                          placeholder=" Exam Time (In Minutes) "
                          value={timer.exam_timer}
                          onChange={timerValueChange}
                        />
                        <label htmlFor="exam_timer">
                          {" "}
                          Exam Time (In Minutes){" "}
                        </label>
                      </div>
                    )}
                  </div>
                  {/*  Question Time (In Minutes)  */}
                  <div className="col-lg-4 ">
                    {timer.set_que_timer && (
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          name="que_timer"
                          id="que_timer"
                          placeholder=" Question Time (In Minutes) "
                          value={timer.que_timer}
                          onChange={timerValueChange}
                        />
                        <label htmlFor="que_timer">
                          {" "}
                          Question Time (In Minutes){" "}
                        </label>
                      </div>
                    )}
                  </div>
                  {/*  Question Time (In Minutes)  */}
                  <div className="col-lg-4 ">
                    {timer.set_warning && (
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          name="warning_seconds"
                          id="warning_seconds"
                          placeholder=" Warning Time (In Minutes) "
                          value={timer.warning_seconds}
                          onChange={timerValueChange}
                        />
                        <label htmlFor="warning_seconds">
                          {" "}
                          Warning Time (In Minutes){" "}
                        </label>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  {/* Suffle for question */}
                  <div className="col-md-4 mt-0">
                    {suffleForQue == 1 ? (
                      <span className="mdi mdi-checkbox-marked-outline mr-3" onClick={() => setSuffleForQue(0)}></span>
                    ) : (
                      <span className="mdi mdi-checkbox-blank-outline mr-3" onClick={() => setSuffleForQue(1)}></span>
                    )}
                    <span>Suffle For Question</span>
                    <span
                      style={{
                        visibility: suffleForQue == 1
                          ? "hidden"
                          : "visible",
                      }}
                    >
                      ?
                    </span>
                  </div>

                  {/* Suffle for option */}
                  <div className="col-md-4 mt-0">
                    {suffleForOpt == 1 ? (
                      <span className="mdi mdi-checkbox-marked-outline mr-3" onClick={() => setSuffleForOpt(0)}></span>
                    ) : (
                      <span className="mdi mdi-checkbox-blank-outline mr-3" onClick={() => setSuffleForOpt(1)}></span>
                    )}
                    <span>Suffle For Option</span>
                    <span
                      style={{
                        visibility: suffleForOpt == 1
                          ? "hidden"
                          : "visible",
                      }}
                    >
                      ?
                    </span>
                  </div>
                </div>

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={createMcqBanksBtn}
                    >
                      {id ? "Update" : "submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddMcqBank;
